// https://stackoverflow.com/a/6661012
const upper = g => g[1].toUpperCase();

const toCamelCase = s => s.replace(/-([a-z])/g, upper);

export default toCamelCase;
